import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, of } from 'rxjs';

export interface FederatedSignInFailure {
  error: string;
  errorDescription?: string;
  identityProvider?: string;
}

@Injectable({ providedIn: 'root' })
export class SignInDiagnosticsService {
  constructor(private http: HttpClient) {}

  reportFederatedFailure(failure: FederatedSignInFailure): void {
    this.http
      .post('/sign-in-failures', failure)
      .pipe(catchError(() => of(null)))
      .subscribe();
  }
}
